/**
 * @generated SignedSource<<67b2d18a004d6ac2c25c63f59ace4b52>>
 * @relayHash 2d0a323560921d26c13a5bbde97017e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 73a6de385aa641103398cb22fd2ae195b3670f73d68d0e7ca59edb5650e22b68

import type { ConcreteRequest } from 'relay-runtime';
export type useContentReportTableDataQuery$variables = {
  cql: string;
  first?: number | null;
  includeComments: boolean;
  includeLikes: boolean;
  skipContentTitle: boolean;
  skipSearchTitle: boolean;
};
export type useContentReportTableDataQuery$data = {
  readonly search: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly comments?: {
          readonly count: number | null;
        } | null;
        readonly creatorId: string | null;
        readonly history: {
          readonly createdBy: {
            readonly displayName: string | null;
          } | null;
        } | null;
        readonly id: string | null;
        readonly likes?: {
          readonly count: number | null;
        } | null;
        readonly space: {
          readonly key: string | null;
        } | null;
        readonly title?: string | null;
        readonly type: string | null;
      } | null;
      readonly lastModified: string | null;
      readonly title?: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
};
export type useContentReportTableDataQuery = {
  response: useContentReportTableDataQuery$data;
  variables: useContentReportTableDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cql"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeComments"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeLikes"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipContentTitle"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipSearchTitle"
},
v6 = [
  {
    "kind": "Variable",
    "name": "cql",
    "variableName": "cql"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v7 = [
  {
    "kind": "ScalarField",
    "name": "title"
  }
],
v8 = {
  "condition": "skipSearchTitle",
  "kind": "Condition",
  "passingValue": false,
  "selections": (v7/*: any*/)
},
v9 = {
  "kind": "ScalarField",
  "name": "url"
},
v10 = {
  "kind": "ScalarField",
  "name": "lastModified"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "condition": "skipContentTitle",
  "kind": "Condition",
  "passingValue": false,
  "selections": (v7/*: any*/)
},
v13 = {
  "kind": "ScalarField",
  "name": "type"
},
v14 = {
  "kind": "ScalarField",
  "name": "creatorId"
},
v15 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v16 = [
  {
    "kind": "ScalarField",
    "name": "count"
  }
],
v17 = {
  "condition": "includeComments",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "PaginatedContentList",
      "kind": "LinkedField",
      "name": "comments",
      "plural": false,
      "selections": (v16/*: any*/)
    }
  ]
},
v18 = {
  "condition": "includeLikes",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "concreteType": "LikesResponse",
      "kind": "LinkedField",
      "name": "likes",
      "plural": false,
      "selections": (v16/*: any*/)
    }
  ]
},
v19 = {
  "kind": "ScalarField",
  "name": "key"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useContentReportTableDataQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v6/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSearchResponse",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "useContentReportTableDataQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v6/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSearchResponse",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          },
                          (v15/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "2d0a323560921d26c13a5bbde97017e0",
    "id": "73a6de385aa641103398cb22fd2ae195b3670f73d68d0e7ca59edb5650e22b68",
    "metadata": {},
    "name": "useContentReportTableDataQuery",
    "operationKind": "query",
    "text": "query useContentReportTableDataQuery($cql:String!,$first:Int,$includeComments:Boolean!,$includeLikes:Boolean!,$skipSearchTitle:Boolean!,$skipContentTitle:Boolean!){search:confluence_search(cql:$cql,first:$first){nodes{title@skip(if:$skipSearchTitle),url,lastModified,content{id,title@skip(if:$skipContentTitle),type,creatorId,history{createdBy{__typename,displayName}},comments@include(if:$includeComments){count},likes@include(if:$includeLikes){count},space{key,id}}}}}"
  }
};
})();

(node as any).hash = "98deec6cf3b490f0ac0c759199a0f911";

export default node;
